/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Emailer {
  static createEmailerTemplate({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = post(`/api/emailTemplates`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    Emailer.createEmailerTemplate.cancel = request.cancel;
    return request;
  }

  static updateEmailerTemplate({ data, templateId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = put(`/api/emailTemplates/${templateId}`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    Emailer.updateEmailerTemplate.cancel = request.cancel;
    return request;
  }

  static getTemplates({ pageNumber = 0, size, sort }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/emailTemplates?page=${pageNumber}&size=${size}&sort=${sort}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Emailer.getTemplates.cancel = request.cancel;
    return request;
  }

  static addRecipients({ data, templateId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/emailTemplates/${templateId}/recipients`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Emailer.addRecipients.cancel = request.cancel;
    return request;
  }

  static sendEmailTemplate({ data, templateId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/emailTemplates/${templateId}/sendEmail`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Emailer.sendEmailTemplate.cancel = request.cancel;
    return request;
  }

  static notificationStatusMarking({ data, templateId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/emailTemplates/${templateId}/markStatus`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Emailer.notificationStatusMarking.cancel = request.cancel;
    return request;
  }

  static uploadEmailAttachments({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const request = post(`/api/emailTemplates/uploadFile`, {
      accessToken: accessTokenFromLocal,
      data,
      headers,
    });

    Emailer.uploadEmailAttachments.cancel = request.cancel;
    return request;
  }

  static getRecipients({ pageNumber = 0, size, templateId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/emailTemplates/${templateId}/recipients?page=${pageNumber}&size=${size}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Emailer.getRecipients.cancel = request.cancel;
    return request;
  }

  static deleteRecipients(templateId, id) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(
      `/api/emailTemplates/${templateId}/recipients/${id}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Emailer.getRecipients.cancel = request.cancel;
    return request;
  }

  static duplicatedTemplate(templateId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/emailTemplates/${templateId}/duplicate`, {
      accessToken: accessTokenFromLocal,
    });

    Emailer.duplicatedTemplate.cancel = request.cancel;
    return request;
  }

  static deleteAllRecipient(templateId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(`/api/emailTemplates/${templateId}/recipients`, {
      accessToken: accessTokenFromLocal,
    });

    Emailer.deleteAllRecipient.cancel = request.cancel;
    return request;
  }

  static getHTMLTemplate(templateId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/emailTemplates/${templateId}`, {
      accessToken: accessTokenFromLocal,
    });

    Emailer.getHTMLTemplate.cancel = request.cancel;
    return request;
  }

  static archiveTemplate(templateId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/emailTemplates/${templateId}/archive`, {
      accessToken: accessTokenFromLocal,
    });

    Emailer.archiveTemplate.cancel = request.cancel;
    return request;
  }
}
